// @flow

import * as request from 'app/utils/request';
import {limitRequests} from 'app/utils/redux';
import type {
  SearchItemType,
  SearchTypeDocument,
  SearchFetchParamsType,
} from './types';
import type {ResponseType} from 'app/utils/redux_v2';
import {gt} from 'app/utils/i18n';
import {requestSearch} from 'app/search/fetchers';

export const searchContentTypes: Array<SearchTypeDocument> = [
  'procedure',
  'proceduregroup',
  'policy',
  'quiz',
];

export type SearchActions = ReceiveSearchResultsActionType;

export const RECEIVE_SEARCH_LIST = 'RECEIVE_SEARCH_LIST';

type ReceiveSearchResultsActionType = {
  +type: 'RECEIVE_SEARCH_LIST',
  query: SearchFetchParamsType,
  response: ResponseType<SearchItemType>,
};
export const receiveSearchResults = (
  query: SearchFetchParamsType,
  response: ResponseType<SearchItemType>
): ReceiveSearchResultsActionType => ({
  type: RECEIVE_SEARCH_LIST,
  query,
  response,
});

export const fetchSearch = limitRequests(
  (fetchParams: SearchFetchParamsType) => (dispatch: SimpleDispatch) => {
    return requestSearch(fetchParams).then(
      (response) => dispatch(receiveSearchResults(fetchParams, response)),
      request.createErrorHandler(gt('Unable to perform search'), dispatch)
    );
  }
);
